/**
 * @fileoverview 예산 관리 유틸리티 함수
 * 예산 사용률 계산, 색상 분류, 월 네비게이션 등 순수 함수 모음
 */

/**
 * 예산 사용률을 계산한다.
 * @param {number} actual - 실제 지출
 * @param {number} budget - 예산
 * @returns {number} 사용률 (%) — budget이 0이면 0 반환
 */
export const calculateUsageRate = (actual, budget) => {
  if (!budget || budget <= 0) return 0;
  return (actual / budget) * 100;
};

/**
 * 전체 예산 사용률을 계산한다.
 * @param {Array} comparisons - [{ budget, actual }, ...]
 * @returns {number} 전체 사용률 (%)
 */
export const calculateOverallUsageRate = (comparisons) => {
  if (!comparisons || comparisons.length === 0) return 0;
  const totalBudget = comparisons.reduce((sum, c) => sum + (c.budget || 0), 0);
  const totalActual = comparisons.reduce((sum, c) => sum + (c.actual || 0), 0);
  if (totalBudget <= 0) return 0;
  return (totalActual / totalBudget) * 100;
};

/**
 * 사용률에 따른 상태 색상 클래스를 반환한다.
 * - > 100%: error (#C4554D)
 * - >= 80%: warning (#487CA5)
 * - < 80%: success (#548164)
 * @param {number} usageRate - 사용률 (%)
 * @returns {string} CSS 클래스명
 */
export const getUsageColorClass = (usageRate) => {
  if (usageRate > 100) return 'budget-usage--error';
  if (usageRate >= 80) return 'budget-usage--warning';
  return 'budget-usage--success';
};

/**
 * 월 문자열에서 이전/다음 월을 계산한다.
 * @param {string} month - 'YYYY-MM' 형식
 * @param {'prev'|'next'} direction - 이동 방향
 * @returns {string} 새 월 문자열 ('YYYY-MM')
 */
export const navigateMonth = (month, direction) => {
  const [year, m] = month.split('-').map(Number);
  const date = new Date(year, m - 1);
  if (direction === 'prev') {
    date.setMonth(date.getMonth() - 1);
  } else {
    date.setMonth(date.getMonth() + 1);
  }
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
};
